<template>
  <SACModal
    modalClass="confirm-exit-popup"
    cardClass="exit-card-container"
    :show="show"
    :close="close"
  >
    <template #content>
      <div class="ac-card-content">
        <div class="ac-body-container">
          <img
            src="@shared/assets/img/general/i-red-diamond.svg"
            class="ac-info-logo"
            alt="Information"
          >
          <div class="ac-header">
            Are you sure?
          </div>
          <div class="ac-body">
            This promo can be re-activated from
            <br>
            My Promos > Inactive > Edit.
          </div>
          <div class="flex-row align-center">
            <button
              type="button"
              class="ac-button"
              @click="close"
            >
              Cancel
            </button>
            <button
              type="button"
              class="ac-button"
              @click="archivePromo"
            >
              Deactivate
            </button>
          </div>
        </div>
      </div>
    </template>
  </SACModal>
</template>

<script>
import SACModal from '@shared/components/sac/SACModal.vue';

export default {
  name: 'ConfirmArchivePopup',
  components: {
    SACModal,
  },
  props: {
    show: Boolean,
    close: Function,
    archivePromo: Function,
  },
};
</script>

<style lang="scss" scoped>

.ac-body {
  font-size: 0.875em !important;
  color: $N90;
  text-align: center;
}
</style>
